import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { State } from 'src/app/shared/models/State';
import { Address } from 'src/app/shared/models/Address';
import { Participant } from 'src/app/shared/models/Participant';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { WSAttendance } from 'src/app/shared/models/WSAttendance';
import { WSParticipantVO } from 'src/app/shared/models/WSParticipantVO';
import { WsAttendanceKey } from 'src/app/shared/models/WsAttendanceKey';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-workshop-participant-detail',
  templateUrl: './workshop-participant-detail.component.html',
  styleUrls: ['./workshop-participant-detail.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopParticipantDetailComponent implements OnInit {

  dataParent: any;
  security: SecurityDocument;
  token: string;
  device: string;
  participant: any;
  workshop: any;

  listLanguage: ValuesVO[];
  selectedLanguage: ValuesVO;

  address: Address;
  namePart: string;
  lastNamePart: string;
  sencondLastNamePart: string;
  email: string;
  city: string;
  neight: string;
  occupation: string;
  age: number;
  cellPhone: string;
  homeNumber: string;
  zipcode: string;
  street: string;
  birthday: string;

  listGender: CategoryLan[];
  selectedGender: CategoryLan;

  listState: State[];
  selectedState: State;


  date1: Date;
  cities: any[];
  value1: number;
  disabled: boolean;

  maxDate: Date = new Date();
  isOutOfRange: boolean = false;

  lbl_go_Back: string = "back_";
  lbl_personal_information: string = "personal_information_";
  lbl_name: string = "name_";
  lbl_last_name: string = "last_name_";
  lbl_language: string = "language_";
  lbl_email: string = "email_";
  lbl_birth_Date: string = "birth_Date_";
  lbl_age: string = "age_";
  lbl_gender: string = "gender_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_home_phone: string = "home_phone_";
  lbl_address: string = "address_";
  lbl_state: string = "state_";
  lbl_county_city: string = "county_city_";
  lbl_neightborhood: string = "neightborhood_";
  lbl_street_and_number: string = "street_and_number_";
  lbl_zip_code: string = "zip_code_";
  lbl_save: string = "save_";
  lbl_delete: string = "delete_record_";
  lbl_select: string = "select_";
  lbl_church_name: string = "church_name_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_are_you_sure = "are_you_sure_";
  lbl_update = "update_";
  lbl_confirm = "confirm_";
  lbl_delete_record_ = "delete_record_";
  lbl_yes: string = "yes_";
  lbl_no: string = "no_";


  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private tovpilUtils: TovpilUtilsService,
    private datePipe: DatePipe) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
      });

    if (this.dataParent) {
      this.security = this.dataParent.security;
      this.participant = this.dataParent.participant;
      this.workshop = this.dataParent.workshop;
    } else {
      this.redirectParticipant();
    }
  }

  ngOnInit(): void {
    this.getTranslatedLabels();
    this.getStatesByCountry();
    this.getGender();
    this.getLanguages();


  }

  redirectParticipant() {

    let queryParamsDetail = {}
    let obj = {
      workshop: this.workshop,
      security: this.security
    }

    if (this.token && this.device) {
      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['guide/workshopsParticipant'], navigationExtras);
  }

  loadDataDetail() {

    if (this.participant != null) {
      this.namePart = this.participant.name;
      this.lastNamePart = this.participant.lastName;
      this.email = this.participant.email;
      this.cellPhone = this.participant.mobPhon;
      this.age = +this.participant.age;
      this.getAddressParticipant(this.participant.address);
      this.birthday = this.datePipe.transform(new Date(this.tovpilUtils.convertStringToDate(this.participant.birthDate).toISOString()), "dd/MM/yyyy");
      this.calculateAge();
    }


  }

  getLanguages() {
    const body = {
      storeId: this.security.storeId,
      language: this.security.language
    }
    this.apiService.getListSpkLangByStoreId(body).then(
      data => {
        this.listLanguage = data;
        if (this.participant) {
          this.selectedLanguage = this.listLanguage.find(l => l.valueId === this.participant.firstLang);
        }
        if (!this.selectedLanguage) {
          this.selectedLanguage = this.listLanguage[0];
        }
      });
  }

  getGender() {
    const body = {
      fieldId: "sex",
      language: this.security.language
    }
    this.apiService.getCategoryLang(body).then(
      data => {
        this.listGender = data;
        if (this.participant) {
          this.selectedGender = this.listGender.find(l => l.fieldVal === this.participant.gender);
        }
      });

  }

  getStatesByCountry() {
    this.apiService.getStatesByCountry(this.security.region).then(
      data => {
        this.listState = data;
        if (this.participant) {
          this.loadDataDetail();
        } else {
          this.selectedState = this.listState.find(l => l.id.stateId == this.workshop.addr.state);
        }
      });

  }

  getAddressParticipant(addrId: string) {
    this.apiService.getAdressById({ addrId: addrId }).then(
      addr => {
        this.address = addr;
        this.city = this.address.city;
        this.neight = this.address.neight;
        this.selectedState = this.listState.find(l => l.id.stateId == this.address.state);
        this.street = this.address.street;
        this.zipcode = this.address.zipCode;
        this.homeNumber = this.address.tel1;

      })
  }

  calculateAge() {

    const fullDatePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/(\d{4})$/;

    if (this.birthday && fullDatePattern.test(this.birthday) && this.birthday.length === 10) {

      const dateParts = this.birthday.split('/');
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Adjust month value since it starts from 0
      const year = parseInt(dateParts[2], 10);

      const tmpDate = new Date(year, month, day);
      let today = new Date();

      let years = today.getFullYear() - tmpDate.getFullYear();

      if (
        today.getMonth() < tmpDate.getMonth() ||
        (today.getMonth() === tmpDate.getMonth() &&
          today.getDate() < tmpDate.getDate())
      ) {
        years--;
      }

      if (years <= 0) {
        years++;
      }

      if (years <= 0) {
        this.messageService.add({ severity: 'error', summary: 'Crear Participante', detail: "Error Fecha Nacimiento", life: 3000 });
      }

      this.age = years;
    }
  }

  checkRange() {
    if (this.age < 18 || this.age > 100) {
      this.isOutOfRange = true;
    } else {
      this.isOutOfRange = false;
    }
  }

  saveParticipant() {
    // if (!this.validateAgeField()) {
    //   this.messageService.add({ severity: 'error', summary: 'Crear Participante', detail: "Fecha Nacimiento Invalida", life: 3000 });
    // } else {
      this.confirmationService.confirm({
        message: this.lbl_are_you_sure + " " + this.lbl_update + "?",
        header: this.lbl_confirm + " " + this.lbl_update,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.lbl_yes,
        rejectLabel: this.lbl_no,
        acceptButtonStyleClass: "p-button-success",
        rejectButtonStyleClass: "p-button-info",
        accept: () => {
          this.createParticipantService();
        }
      });
    // }
  }

  validateAgeField(): boolean {
    const birthdayRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/(\d{4})$/;
    const ageValid = this.age >= 5 && this.age <= 100;
    const birthdayValid = birthdayRegex.test(this.birthday);

    return ageValid && birthdayValid;
  }

  createParticipantService() {
    // this.calculateAge();
    let day, month, year;
    let dateObj;
    if(this.birthday != null){
      [day, month, year] = this.birthday.split('/')
      dateObj = new Date(+year, +month - 1, +day)
    }
    
    let participantView: Participant = {
      particiId: this.participant != null ? this.participant.particiId : "",
      name: this.namePart != null ? this.namePart : null,
      lastName: this.lastNamePart != null ? this.lastNamePart : null,
      birthDate: this.birthday != null ? this.tovpilUtils.dateToTovpilDate(dateObj) : null,
      gender: this.selectedGender != null ? this.selectedGender.fieldVal : null,
      privData: true,
      firstLang: this.selectedLanguage != null ? this.selectedLanguage.valueId : null,
      email: this.email,
      mobPhon: this.cellPhone,
      address: this.address != null ? this.address.addrId : null,
      age: this.age != null ? this.age.toString() : "",
    }
    let addressSend: Address = {
      addrId: this.address != null ? this.address.addrId : null,
      country: this.workshop.addr.country,
      state: this.selectedState != null ? this.selectedState.id.stateId : null,
      personType: "P",
      city: this.city ? this.city : null,
      neight: this.neight ? this.neight : null,
      storeId: "",
      street: this.street,
      latitude: null,
      longitude: null,
      tel1: this.homeNumber,
      zipCode: this.zipcode

    }



    const WsAttendanceKey = { wrksId: this.workshop.f0.wrksId, sessNum: "00" };
    const wSAttendance: WSAttendance = { id: WsAttendanceKey, attendId: "" }
    const wSParticipantVO: WSParticipantVO = { attendance: wSAttendance, participant: participantView, address: addressSend, language: this.security.language }


    this.apiService.createWSParticipantWrp(wSParticipantVO).then(
      data => {
        if (data.status == 'OK') {
          this.messageService.add({ severity: 'success', summary: 'Crear Participante', detail: 'Se creó participante correctamente', life: 3000 });
          this.redirectParticipant();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Crear Participante', detail: data.errorMessage, life: 9000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Crear Participante', detail: error, life: 3000 });
      });
  }

  deleteParticipant() {
    this.confirmationService.confirm({
      message: this.lbl_are_you_sure + " " + this.lbl_delete_record_ + "?",
      header: this.lbl_confirm + " " + this.lbl_delete_record_,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteParticipantService();
      }
    });
  }

  deleteParticipantService() {
    this.apiService.deleteParticipantForm0({
      wrksId: this.workshop.f0.wrksId,
      id: this.participant.particiId,
      language: this.security.language
    }).then(
      data => {

        this.messageService.add({ severity: 'success', summary: 'Eliminar Participante', detail: 'Se elimino participante correctamente', life: 3000 });
        this.redirectParticipant();
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Eliminar Participante', detail: error, life: 3000 });
      });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_personal_information, this.lbl_name, this.lbl_last_name, this.lbl_language, this.lbl_email, this.lbl_birth_Date, this.lbl_age, this.lbl_gender, this.lbl_cell_phone, this.lbl_home_phone, this.lbl_address, this.lbl_state, this.lbl_county_city, this.lbl_neightborhood, this.lbl_street_and_number, this.lbl_save, this.lbl_delete, this.lbl_select, this.lbl_church_name, this.lbl_workshop, this.lbl_schedule, this.lbl_zip_code, this.lbl_are_you_sure, this.lbl_update, this.lbl_confirm, this.lbl_delete_record_, this.lbl_yes, this.lbl_no]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_personal_information = map.get(this.lbl_personal_information);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_last_name = map.get(this.lbl_last_name);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_birth_Date = map.get(this.lbl_birth_Date);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_home_phone = map.get(this.lbl_home_phone);
        this.lbl_address = map.get(this.lbl_address);
        this.lbl_state = map.get(this.lbl_state);
        this.lbl_county_city = map.get(this.lbl_county_city);
        this.lbl_neightborhood = map.get(this.lbl_neightborhood);
        this.lbl_street_and_number = map.get(this.lbl_street_and_number);
        this.lbl_zip_code = map.get(this.lbl_zip_code);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_update = map.get(this.lbl_update);
        this.lbl_delete_record_ = map.get(this.lbl_delete_record_);
        this.lbl_yes = map.get(this.lbl_yes);
        this.lbl_no = map.get(this.lbl_no);

      });
  }
  goBack() {
    window.close();
  }
}
